import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { LgdRadioGroupComponent } from "./lgdRadioGroup.component";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { defineRadioComponent, defineTooltipComponent } from "@tylertech/forge";
import { ForgeModule } from "@tylertech/forge-angular";
defineRadioComponent();
defineTooltipComponent();
@NgModule({
    imports: [CommonModule, ReactiveFormsModule, ForgeModule, FlexLayoutModule],
    declarations: [LgdRadioGroupComponent],
    exports: [
        ReactiveFormsModule,
        LgdRadioGroupComponent
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LgdRadioGroupModule { }
